$(document).ready(function () {

  const $checkGiftCardBalance = $('#js-check-gift-balance');
  const $redeemGiftCardAmount = $('#js-gift-redeem');

  $checkGiftCardBalance.click(function (e) {
    e.preventDefault();
    const $giftCardNumberInput = $('input[name="gift-card-number"]')

    $.ajax({
      type: 'GET', // define the type of HTTP verb we want to use (POST for our form)
      url: 'https://giftcards.macknade.kayo.dev/api/check-gift-card-balance', // the url where we want to POST
      data: {
        giftCardNumber: $giftCardNumberInput.val()
      },
      encode: true,
      crossDomain: true,
      beforeSend: function(xhr) {
        xhr.setRequestHeader('X-API-KEY', '23dxbhhd1w4k48cg0o0w8g04kgcwoww');
      },
      success: function(response) {
        $('#gift-card-check').hide();
        $('#js-gift-value').text("£" + response.balance);
        $('input[name="gift-card-amount"]')
          .attr('max',response.balance)
          .val(response.balance);
        $('#gift-card-balance-check').show()
      },
      error: function(xhr, resp, text) {
        $('#js-check-gift-balance-error').show()
        console.log(xhr, resp, text);
      }
    });
  });

  $redeemGiftCardAmount.click(function(e){
    e.preventDefault();
    const $giftCardNumberInput = $('input[name="gift-card-number"]');
    const $giftCardValue =  $('input[name="gift-card-amount"]');
    const $customerId =  $('input[name="customer-id"]');
    $.ajax({
      type: 'POST', // define the type of HTTP verb we want to use (POST for our form)
      url: 'https://giftcards.macknade.kayo.dev/api/generate-discount', // the url where we want to POST
      data: {
        customerId: $customerId.val(),
        giftCardNumber: $giftCardNumberInput.val(),
        value: $giftCardValue.val()
      },
      encode: true,
      crossDomain: true,
      beforeSend: function(xhr) {
        xhr.setRequestHeader('X-API-KEY', '23dxbhhd1w4k48cg0o0w8g04kgcwoww');
      },
      success: function(response) {
        $('#gift-card-balance-check').hide();
        $('#gift-card-code').val(response.voucherCode)
        $('#js-voucher-amount').text("£" + response.value);
        $('#gift-card-success').show();
      },
      error: function(xhr, resp, text) {
        console.log(xhr, resp, text);
      }
    });

  })

});
